import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreDirectivesModule } from '@core/directives/directives';
import { TranslocoModule } from '@jsverse/transloco';
import { CrossIconSvgComponent } from 'app/main/pages/settings/documenttype/document-type-settings-modal/cross-icon-svg/cross-icon-svg.component';
import { EyeCloseIconSvgComponent } from 'app/main/pages/settings/documenttype/document-type-settings-modal/eye-close-icon-svg/eye-close-icon-svg.component';
import { EyeIconSvgComponent } from 'app/main/pages/settings/documenttype/document-type-settings-modal/eye-icon-svg/eye-icon-svg.component';
import { LockIconSvgComponent } from 'app/main/pages/settings/documenttype/document-type-settings-modal/lock-icon-svg/lock-icon-svg.component';



@NgModule({
  declarations: [
    LockIconSvgComponent,
    CrossIconSvgComponent,
    EyeIconSvgComponent,
    EyeCloseIconSvgComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    CoreDirectivesModule
  ],
  exports: [
    LockIconSvgComponent,
    CrossIconSvgComponent,
    EyeIconSvgComponent,
    EyeCloseIconSvgComponent
  ]
})
export class SvgIconsModule { }
